export const Media = (json: IMedia): IMediaModel => {
	const fromJSON = () => {
		const { collection_name, file_name, preview_url, original_url, order_column, responsive_images, ...rest } = json

		return {
			collectionName: collection_name,
			fileName: file_name,
			previewURL: preview_url,
			originalURL: original_url,
			orderColumn: order_column,
			responsiveImages: responsive_images,
			...rest,
		}
	}
	return { ...fromJSON() }
}

export const mediaToJSON = (obj: Partial<IMediaModel>): Partial<IMedia> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}

export const mediaFormToJSON = (obj: Partial<IMediaFormModel>): Partial<IMediaForm> => {
	const { collectionName, entityID, ...rest } = obj
	return {
		collection_name: collectionName,
		entity_id: entityID,
		...rest,
	}
}
